export default __webpack_public_path__ + "static/media/tania.bc44d816.jpg";